"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "santa-maria-di-sala": {
    "1047dd5c": [{
      "hkey": "28c3bb16",
      "slug": "santa-maria-di-sala",
      "name": "Santa Maria di Sala",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-fiorito": [{
      "hkey": "28c3bb16",
      "slug": "santa-maria-di-sala",
      "name": "Santa Maria di Sala",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "801d94ef": [{
      "hkey": "28c3bb16",
      "slug": "santa-maria-di-sala",
      "name": "Santa Maria di Sala",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-mora": [{
      "hkey": "28c3bb16",
      "slug": "santa-maria-di-sala",
      "name": "Santa Maria di Sala",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e87ef5bd": [{
      "hkey": "28c3bb16",
      "slug": "santa-maria-di-sala",
      "name": "Santa Maria di Sala",
      "primary": true,
      "skipSearch": false
    }],
    "tabina": [{
      "hkey": "28c3bb16",
      "slug": "santa-maria-di-sala",
      "name": "Santa Maria di Sala",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f92bc310": [{
      "hkey": "32681d82",
      "slug": "veternigo",
      "name": "Veternigo",
      "primary": true,
      "skipSearch": false
    }],
    "veternigo-localita-tre-ponti": [{
      "hkey": "32681d82",
      "slug": "veternigo",
      "name": "Veternigo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;